/**
 * Enums do domínio MyMAXX. Espelham os enums do schema Prisma (apps/api/prisma/schema.prisma).
 * Mantidos aqui em TS puro para o painel, o chat-web e o app não dependerem do Prisma.
 */
export const StatusConversa = {
    BOT: 'bot',
    FILA: 'fila',
    EM_ATENDIMENTO: 'em_atendimento',
    AGUARDANDO_CLIENTE: 'aguardando_cliente',
    ENCERRADA: 'encerrada',
};
export const NivelIdentidade = {
    VISITANTE: 'visitante',
    VERIFICADO: 'verificado',
};
export const OrigemConversa = {
    WEB: 'web',
    APP: 'app',
};
export const AutorMensagem = {
    CLIENTE: 'cliente',
    ATENDENTE: 'atendente',
    BOT: 'bot',
    SISTEMA: 'sistema',
};
export const TipoMensagem = {
    TEXTO: 'texto',
    IMAGEM: 'imagem',
    AUDIO: 'audio',
    ARQUIVO: 'arquivo',
    /** Registro de uma chamada de voz na conversa interna. Nunca o áudio dela. */
    CHAMADA: 'chamada',
    /** Aviso do próprio sistema no fio interno ("Fulano virou dono do grupo"). Sem autor. */
    AVISO: 'aviso',
    NOTA_INTERNA: 'nota_interna',
    SUSSURRO: 'sussurro',
};
/** Tipos que existem só para a equipe — jamais saem no fio que o cliente lê. */
export const TIPOS_SO_DA_EQUIPE = ['nota_interna', 'sussurro'];
export const PapelParticipante = {
    TITULAR: 'titular',
    APOIO: 'apoio',
};
export const StatusPresenca = {
    ONLINE: 'online',
    PAUSA: 'pausa',
    OFFLINE: 'offline',
};
export const PapelSetor = {
    ATENDENTE: 'atendente',
    SUPERVISOR: 'supervisor',
};
export const VisibilidadeCampo = {
    OCULTO: 'oculto',
    MASCARADO: 'mascarado',
    COMPLETO: 'completo',
};
/** Campos de dados pessoais do cliente cuja visibilidade é configurável por perfil (D13). */
export const CAMPOS_PII_CLIENTE = ['nome', 'cpf', 'telefone', 'email', 'endereco'];
export const FinalidadeOtp = {
    CRIAR_CONTA: 'criar_conta',
    LOGIN: 'login',
    VERIFICAR_NO_CHAT: 'verificar_no_chat',
};
export const CanalOtp = {
    SMS: 'sms',
    EMAIL: 'email',
};
/** Fuso horário oficial do produto (protocolos, horários de atendimento, relatórios). */
export const FUSO_HORARIO = 'America/Sao_Paulo';
//# sourceMappingURL=enums.js.map